<template>
    <div class="delivery-maintain">
        <div class="delivery-maintain-chart">
            <div class="delivery-maintain-date">
                <span class="label">时间区间：</span>
                <el-date-picker
                        size="mini"
                        v-model="makeTimeRange"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <delivery-maintain-pie class="maintain-chart"></delivery-maintain-pie>

        </div>

        <div class="delivery-maintain-list">
            <div class="delivery-maintain-title">
                <span class="table-name">保养明细</span>
                <span class="data-export">数据导出</span>
                <div class="delivery-maintain-date float-right clearfix">
                    <span class="label">时间区间：</span>
                    <el-date-picker
                            size="mini"
                            v-model="makeTimeRange"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
            <el-table :data="maintains">
                <el-table-column label="异常名称" align="center" prop="name"></el-table-column>
                <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceUuid"></el-table-column>
                <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="deviceName"></el-table-column>
                <el-table-column label="异常时间" align="center" prop="createdAt"></el-table-column>
            </el-table>

            <el-pagination
                    class="pagination"
                    :current-page="currentPage"
                    :page-size="100"
                    layout="total, prev, pager, next, jumper"
                    :total="400">
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import DeliveryMaintainPie from '@/components/DeliveryMaintainPie/index.vue'
    export default {
        name: '',
        components: {
            DeliveryMaintainPie
        },
        mounted: function () {
        },
        data: function () {
            return {
                makeTimeRange: [],
                pickerOptions: {
                    shortcuts: [{
                        text: this.$t('jin_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0)
                            end.setHours(23, 59, 59, 0)
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zuo_tian'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            start.setHours(0, 0, 0, 0)
                            end.setTime(end.getTime() - 3600 * 1000 * 24);
                            end.setHours(23, 59, 59, 0)

                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_zhou'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_yi_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                         text: this.$t('zui_jin_san_yue'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                maintains: [
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                    {name: '系统缺水', deviceUuid: '4c3b26f02801000', deviceName: '测试设备', createdAt: '2019-09-08 13:52:56'},
                ],
                currentPage: 1,
            }
        },
        methods: {},
    }
</script>

<style lang="scss">
    .delivery-maintain {
        margin-bottom: $padding;
        display: flex;
        flex-direction: column;

        .delivery-maintain-date {
            text-align: right;
            .label {
                font-size: .6rem;
                color: $f_sec_color;
                font-weight: $w1;
            }
            .el-range-input {
                border: none;
            }
            input {
                border: none;
                border-bottom: 1px solid $f_fiv_color;
                font-size: $filter-font-size;
                border-radius: 0;
            }
        }

        .delivery-maintain-chart {
            border: 1px solid $border_sec_color;
            border-radius: .5rem;
            background-color: $bg_sec_color;
            padding: $padding;
            .maintain-chart {
                margin-top: $padding-5;
                height: 20rem;
            }

        }

        .delivery-maintain-list {
            flex: 1;
            margin: $padding 0;
            border: 1px solid $border_sec_color;
            border-radius: .5rem;
            background-color: $bg_sec_color;
            padding: $padding;
            .delivery-maintain-title {
                .table-name {
                    color: $f_sec_color;
                    font-weight: $w1;
                    font-size: .8rem;
                }

                .data-export {
                    color: $f_color;
                    font-size: .6rem;
                    display: inline-block;
                    margin-left: $padding-5;
                    cursor: pointer;
                }

                .float-right {
                    float: right;
                }
            }
            .el-table th.is-leaf {
                border-color: $border_th_color;
            }
            .el-table:before {
                background-color: transparent;
            }
            .pagination {
                margin-top: $padding;
                text-align: right;
            }
        }
    }
</style>
